export const devices = {
  mobile: "480px",
  desktop: "768px"
};

export const heights = {
  header: "48px",
  footer: "48px"
};

export const colors = {
  black: "#000",
  blackThin: "#292929",
  white: "#fff",
  gray: "#404040",
  pink: "#fe879b",
  lightgray: "#666666",
  red: "#C1272D",

  // 3rd party services
  facebook: "#3b5998",
  line: "#00b900",
  twitter: "#55acee"
};
